import { datadogRum } from '@datadog/browser-rum';
const env = process.env.NODE_ENV;

export const onClientEntry = () => {
    datadogRum.init({
        applicationId: '4d151176-7359-4c83-9f72-869a96c595a7',
        clientToken: 'pub70865f1aadd17badfa330c74266f3425',
        site: 'datadoghq.com',
        service: 'autobell-frontend',
        env: env,

        // Specify a version number to identify the deployed version of your application in Datadog
        // version: '1.0.0',
        defaultPrivacyLevel: 'mask-user-input',
        traceSampleRate: 50,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 20,
        trackResources: true,
        trackLongTasks: true,
        trackUserInteractions: true,
        beforeSend: (event) => {
            if (
                (event.type === 'error' &&
                    event.error.message.startsWith('Warning:')) ||
                env === 'development'
            )
                return false;
        }
    });
    window.datadogRum = datadogRum;
};

let nextRoute = ``;

export const onPreRouteUpdate = ({ location }) => {
    nextRoute = location.pathname;
};

export const shouldUpdateScroll = ({
    routerProps: { location },
    getSavedScrollPosition
}) => {
    const currentPosition = getSavedScrollPosition(location);
    setTimeout(() => window.scrollTo(...(currentPosition || [0, 0])), 0);
    return false;
};

if (typeof window !== `undefined`) {
    window.addEventListener('unhandledrejection', function (event) {
        if (/loading chunk \d* failed./i.test(event.reason)) {
            if (nextRoute) {
                window.location.pathname = nextRoute;
            }
        }
    });

    // Fix Windows browsers not including scrollbars in vw calculations
    function setVw() {
        let vw = document.documentElement.clientWidth / 100;
        document.documentElement.style.setProperty('--vw', `${vw}px`);
    }
    setVw();
    window.addEventListener('resize', setVw);

    if (!window.crypto) {
        window.crypto = window.msCrypto;
    }
}

export { wrapRootElement } from './gatsby-ssr';

export { wrapPageElement } from './gatsby-ssr';
